import { render, staticRenderFns } from "./DrawingsView.vue?vue&type=template&id=45019082"
import script from "./DrawingsView.vue?vue&type=script&lang=ts"
export * from "./DrawingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports